module.exports = __webpack_public_path__ + "img/android-chrome-192x192.983e83bd.png";